import SbuxDialog2 from "../../../../components/SbuxDialog2";
import SbuxTranslate from "../../../../components/SbuxTranslate";
import {
  Box,
  Button,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import type {
  PhoneNumberRecord,
  InstanceRecord,
  ContactFlowRecord,
} from "./types";

interface Selections {
  currentInstance: Record<string, unknown>;
  phoneNumber: PhoneNumberRecord;
  instance: InstanceRecord;
  contactFlow?: ContactFlowRecord | null;
}

interface Props {
  open: boolean;
  selections: Selections;
  handleOnClose: () => void;
  handleConfirmDialog: () => void;
  handleCancelDialog: () => void;
}

/**
 * Confirmation dialog
 * @param {object} props  component props
 */
const ConfirmActionModal = ({
  open,
  selections,
  handleOnClose,
  handleConfirmDialog,
  handleCancelDialog,
}: Props) => {
  const dialogConfig = {
    title: <SbuxTranslate>{`Action summary`}</SbuxTranslate>,
    hasBackdrop: false,
    asModal: true,
    disableBackdropClose: false,
  };

  /**
   * Creates dialog content summary
   */
  const createSummary = ({
    currentInstance,
    phoneNumber,
    instance,
    contactFlow,
  }: Selections) => {
    return (
      <Box>
        <Typography variant="h5" gutterBottom>
          <SbuxTranslate>{`Phone number`}</SbuxTranslate>{" "}
          <strong>{`${phoneNumber.PhoneNumber}`}</strong>{" "}
          <SbuxTranslate>{`from instance`}</SbuxTranslate>{" "}
          <strong>{`${currentInstance.instanceAlias}`}</strong>{" "}
          <SbuxTranslate>{`will be ported to`}</SbuxTranslate>{" "}
          {contactFlow && (
            <>
              <SbuxTranslate>{`contact flow`}</SbuxTranslate>{" "}
              <strong>{`${contactFlow.Name}`}</strong>{" "}
              <SbuxTranslate>{`which is associated to`}</SbuxTranslate>{" "}
            </>
          )}
          <SbuxTranslate>{`instance`}</SbuxTranslate>{" "}
          <strong>{`${instance.InstanceAlias}`}</strong>.{" "}
          <SbuxTranslate>{`Confirm change?`}</SbuxTranslate>
        </Typography>
      </Box>
    );
  };

  return (
    <SbuxDialog2
      open={open}
      config={dialogConfig}
      handleOnClose={handleOnClose}
    >
      <DialogContent dividers>{createSummary(selections)}</DialogContent>

      <DialogActions>
        <Box className="actionContainer">
          <Button
            variant="contained"
            size="medium"
            onClick={handleConfirmDialog}
          >
            <SbuxTranslate>{"Confirm"}</SbuxTranslate>
          </Button>
          <Button variant="outlined" size="medium" onClick={handleCancelDialog}>
            <SbuxTranslate>{"Cancel"}</SbuxTranslate>
          </Button>
        </Box>
      </DialogActions>
    </SbuxDialog2>
  );
};

export default ConfirmActionModal;
